"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustedMessageType = exports.SnackbarMessageType = exports.OtpTrustedChallengeStateType = exports.FinishAuthoriserFlowReason = exports.OtpChallengeChannel = exports.ChallengeType = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "ChallengeType", { enumerable: true, get: function () { return features_1.ChallengeType; } });
Object.defineProperty(exports, "OtpChallengeChannel", { enumerable: true, get: function () { return features_1.OtpChallengeChannel; } });
Object.defineProperty(exports, "FinishAuthoriserFlowReason", { enumerable: true, get: function () { return features_1.FinishAuthoriserFlowReason; } });
const types_1 = require("../../authoriser/types");
var OtpTrustedChallengeStateType;
(function (OtpTrustedChallengeStateType) {
    OtpTrustedChallengeStateType["ERROR"] = "ERROR";
    OtpTrustedChallengeStateType["DEFAULT"] = "DEFAULT";
    OtpTrustedChallengeStateType["SUCCESS"] = "SUCCESS";
    OtpTrustedChallengeStateType["WARNING"] = "WARNING";
})(OtpTrustedChallengeStateType = exports.OtpTrustedChallengeStateType || (exports.OtpTrustedChallengeStateType = {}));
var SnackbarMessageType;
(function (SnackbarMessageType) {
    SnackbarMessageType["ERROR"] = "ERROR";
    SnackbarMessageType["SUCCESS"] = "SUCCESS";
})(SnackbarMessageType = exports.SnackbarMessageType || (exports.SnackbarMessageType = {}));
var TrustedMessageType;
(function (TrustedMessageType) {
    TrustedMessageType["INFORMATION"] = "INFORMATION";
    TrustedMessageType["ERROR"] = "ERROR";
    TrustedMessageType["SECOND_ERROR"] = "SECOND_ERROR";
})(TrustedMessageType = exports.TrustedMessageType || (exports.TrustedMessageType = {}));
//# sourceMappingURL=index.js.map